export default __webpack_public_path__ + "static/media/Designo - Portfolio.e3344fd3.png";